import { React, useState, useEffect } from "react";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import PGLoaders from "../../default-pages/PGLoaders/PGLoaders";
const LoaderSetting = () => {
  const { user } = useAuthContext();

  const { updateDocument } = useFirestore("settings");
  const [activeLoader, setActiveLoader] = useState("");

  const { document: loaderTypeDoc, error: loaderTypeDocerror } = useDocument(
    "settings",
    "loaders"
  );

  useEffect(() => {
    if (loaderTypeDoc) {
      setActiveLoader(loaderTypeDoc.activeLoader || "");
    }
  }, [loaderTypeDoc]);

  const loaderTypeLabels = {
    // dottedspinner: "Dotted Loader",
    // skeletonloader: "Skeleton Loader",
    // circularloader: "Circular Loader",
    // cubeloader: "Cube Loader",
    BarLoader: "Bar Loader",
    BounceLoader: "Bounce Loader",
    CircleLoader: "Circle Loader",
    ClimbingBoxLoader: "Climbing Box Loader",
    ClipLoader: "Clip Loader",
    ClockLoader: "Clock Loader",
    DotLoader: "Dot Loader",
    FadeLoader: "Fade Loader",
    GridLoader: "Grid Loader",
    HashLoader: "Hash Loader",
    MoonLoader: "Moon Loader",
    PacmanLoader: "Pacman Loader",
    PropagateLoader: "Propagate Loader",
    PuffLoader: "Puff Loader",
    PulseLoader: "Pulse Loader",
    RingLoader: "Ring Loader",
    RiseLoader: "Rise Loader",
    RotateLoader: "Rotate Loader",
    ScaleLoader: "Scale Loader",
    SkewLoader: "Skew Loader",
    SquareLoader: "Square Loader",
    SyncLoader: "Sync Loader",
    BeatLoader: "Beat Loader",
  };

  const handleLoaderChange = async (loaderTypeLabel) => {
    try {
      const selectedLoader = loaderTypeLabel;
      await updateDocument("loaders", { activeLoader: selectedLoader });
    } catch (error) {
      console.error("Error updating user nav type:", error);
    }
  };
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-8">
            {user && (user.role === "admin" || user.role === "superAdmin") && (
              <div className="role">
                <div className="section-title">
                  <p>Loader Setting</p>
                  <h2>Select Your Best Loader</h2>
                </div>
                <div className="radio-container">
                  {Object.keys(loaderTypeLabels).map((loaderType, index) => (
                    <label
                      key={index}
                      className={`radio-container ${
                        activeLoader === loaderType
                          ? "radio_btn_checked"
                          : "service_details_radion_btn"
                      }`}
                      style={{
                        backgroundColor:
                          activeLoader === loaderType
                            ? "var(--click-color)"
                            : "inherit",
                      }}
                    >
                      <div className="d-flex align-items-center">
                        <input
                          type="radio"
                          name="nav"
                          value={loaderType}
                          onChange={() => {
                            setActiveLoader(loaderType);
                            handleLoaderChange(loaderType);
                          }}
                          className="radio-button-with-radius"
                        />
                        <span
                          className="material-symbols-outlined"
                          style={{
                            fontSize: "21px",
                            color: "var(--black-color)",
                          }}
                        >
                          {activeLoader === loaderType ? "done" : "add"}
                        </span>
                        <span style={{ color: "var(--black-color)" }}>
                          {loaderTypeLabels[loaderType]}
                        </span>
                      </div>
                    </label>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div
            className="col-12 col-md-4 d-flex align-items-center justify-content-center"
            style={{ minHeight: "100px" }}
          >
            <PGLoaders />
          </div>
        </div>
        <br />
        <p style={{ fontSize: "13px" }}>
          <span style={{ fontWeight: "bold", color: "var(--red-color)" }}>
            Note:&nbsp;
          </span>
          <span style={{ color: "var(--grey-dark)" }}>
            Loader Design: After selecting the Loader button, you can explore
            the design of the selected Loader on the website.
          </span>
        </p>
      </div>
    </div>
  );
};

export default LoaderSetting;
